import { featureFlags } from '@/store/feature-flag.store';

export const THREE_HOUR_TIME_WINDOW_FLAG = 'BOOKING_RMD_3H_TIME_WINDOW';

export function isThreeHourTimeWindowEnabled(): boolean {
    return featureFlags.getFeatureFlag(THREE_HOUR_TIME_WINDOW_FLAG);
}

export function getDeliveryTimeWindowHours(): number {
    return isThreeHourTimeWindowEnabled() ? 3 : 2;
}
